import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SendIcon, CheckCircleIcon } from 'lucide-react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    instagram: '',
    website: '',
    currentClients: '',
    goalClients: '',
    hasDoneAds: '',
    adSpend: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      setIsSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        instagram: '',
        website: '',
        currentClients: '',
        goalClients: '',
        hasDoneAds: '',
        adSpend: ''
      });
    } catch (error) {
      console.error('Error submitting form', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact-form" className="py-24 bg-[#000000] border-t border-white/5 relative" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="max-w-3xl mx-auto" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0A0A0A] p-8 md:p-12 rounded-3xl border border-[#50C878]/30 shadow-[0_0_30px_rgba(80,200,120,0.15)] hover:shadow-[0_0_40px_rgba(80,200,120,0.25)] transition-shadow duration-500" data-id="element-15">
            <div className="text-center mb-10" data-id="element-16">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4" data-id="element-17">
                Solicita tu{' '}
                <span className="text-[#FFD700] drop-shadow-[0_0_8px_rgba(255,215,0,0.3)]" data-id="element-18">
                  Prescripción
                </span>{' '}
                HVAC
              </h2>
              <p className="text-[#C0C0C0]" data-id="element-19">
                Completa el formulario para analizar tu negocio HVAC. Solo
                trabajamos con una empresa por área para garantizar
                exclusividad.
              </p>
            </div>

            {isSuccess ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-[#50C878]/10 border border-[#50C878]/40 rounded-2xl p-8 text-center shadow-[0_0_20px_rgba(80,200,120,0.2)]" data-id="element-20">
                <CheckCircleIcon className="w-16 h-16 text-[#50C878] mx-auto mb-4 drop-shadow-[0_0_10px_rgba(80,200,120,0.5)]" data-id="element-21" />
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-22">
                  ¡Prescripción Solicitada!
                </h3>
                <p className="text-[#C0C0C0] mb-6" data-id="element-23">
                  Nos pondremos en contacto contigo pronto. Para asegurar tu
                  espacio, agenda tu cita directamente en nuestro calendario
                  ahora mismo.
                </p>
                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#FFD700] text-black font-bold px-8 py-4 rounded-lg hover:bg-[#e6c200] transition-colors neon-glow uppercase tracking-wide" data-id="element-24">
                  Agendar en Google Calendar
                </a>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-25">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-26">
                  <div data-id="element-27">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-28">
                      Nombre Completo *
                    </label>
                    <input required type="text" name="name" value={formData.name} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="Ej. Juan Pérez" data-id="element-29" />
                  </div>
                  <div data-id="element-30">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-31">
                      Email *
                    </label>
                    <input required type="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="juan@empresa.com" data-id="element-32" />
                  </div>
                  <div data-id="element-33">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-34">
                      Teléfono *
                    </label>
                    <input required type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="+1 (555) 000-0000" data-id="element-35" />
                  </div>
                  <div data-id="element-36">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-37">
                      Nombre de la Compañía *
                    </label>
                    <input required type="text" name="company" value={formData.company} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="HVAC Solutions LLC" data-id="element-38" />
                  </div>
                  <div data-id="element-39">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-40">
                      Instagram de la Compañía
                    </label>
                    <input type="text" name="instagram" value={formData.instagram} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="@tuempresa" data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-43">
                      Website (si tienes)
                    </label>
                    <input type="url" name="website" value={formData.website} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="https://www.tuempresa.com" data-id="element-44" />
                  </div>
                </div>

                <div className="h-px w-full bg-white/10 my-6" data-id="element-45"></div>

                <div className="space-y-6" data-id="element-46">
                  <div data-id="element-47">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-48">
                      ¿Cuántos clientes tienes por semana actualmente? *
                    </label>
                    <select required name="currentClients" value={formData.currentClients} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all appearance-none" data-id="element-49">
                      <option value="" data-id="element-50">Selecciona una opción</option>
                      <option value="0-5" data-id="element-51">0 - 5 clientes</option>
                      <option value="6-15" data-id="element-52">6 - 15 clientes</option>
                      <option value="16-30" data-id="element-53">16 - 30 clientes</option>
                      <option value="30+" data-id="element-54">Más de 30 clientes</option>
                    </select>
                  </div>

                  <div data-id="element-55">
                    <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-56">
                      ¿Cuál es tu meta semanal de clientes nuevos? *
                    </label>
                    <input required type="text" name="goalClients" value={formData.goalClients} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="Ej. 10 instalaciones nuevas" data-id="element-57" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-58">
                    <div data-id="element-59">
                      <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-60">
                        ¿Has hecho publicidad antes (Ads)? *
                      </label>
                      <select required name="hasDoneAds" value={formData.hasDoneAds} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all appearance-none" data-id="element-61">
                        <option value="" data-id="element-62">Selecciona una opción</option>
                        <option value="si" data-id="element-63">Sí, actualmente</option>
                        <option value="si_pasado" data-id="element-64">Sí, en el pasado</option>
                        <option value="no" data-id="element-65">No, nunca</option>
                      </select>
                    </div>
                    <div data-id="element-66">
                      <label className="block text-sm font-bold text-[#C0C0C0] mb-2" data-id="element-67">
                        Si respondiste sí, ¿cuánto has gastado aprox?
                      </label>
                      <input type="text" name="adSpend" value={formData.adSpend} onChange={handleChange} className="w-full bg-[#111111] border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" placeholder="Ej. $500/mes" data-id="element-68" />
                    </div>
                  </div>
                </div>

                <div className="pt-8" data-id="element-69">
                  <button type="submit" disabled={isSubmitting} className={`w-full bg-[#FFD700] text-black font-black text-lg px-8 py-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 uppercase tracking-wide ${isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:bg-[#e6c200] neon-glow'}`} data-id="element-70">
                    {isSubmitting ? 'Procesando...' : 'ENVIAR MI PRESCRIPCIÓN'}
                    {!isSubmitting && <SendIcon className="w-5 h-5" data-id="element-71" />}
                  </button>
                  <p className="text-center text-[#C0C0C0] text-xs mt-4 font-medium" data-id="element-72">
                    Tus datos están protegidos bajo secreto profesional.
                  </p>
                </div>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}